import React, { useRef, useState } from "react";

const closeDropdown = (bodyClickHandler, setBodyClickHandler, setExpanded) => {
  document.removeEventListener('click', bodyClickHandler);
  setBodyClickHandler(null);
  setExpanded(false);
};

const offClickHandler = (event, dropdownContainer, bodyClickHandler, setBodyClickHandler, setExpanded) => {
  if (!dropdownContainer.current.contains(event.target)) {
    closeDropdown(bodyClickHandler, setBodyClickHandler, setExpanded);
  }
};

const FurtherReadingDropdown = (props) => {
  const dropdownRef = useRef();

  const [expanded, setExpanded] = useState(false);
  const [bodyClickHandler, setBodyClickHandler] = useState(null);

  
  return (
    <div
      className={`further-reading__dropdown ${props.format ? `format-${props.format}` : ''}`}
      ref={dropdownRef}
    >
      <div
        className="further-reading__dropdown__target"
        onClick={() => {
          if (expanded) {
            closeDropdown(bodyClickHandler, setBodyClickHandler, setExpanded);
          } else {
            setExpanded(true);
            setBodyClickHandler(
              document.addEventListener('click', (e) => {
                offClickHandler(e, dropdownRef, bodyClickHandler, setBodyClickHandler, setExpanded)
              })
            );
          }
        }}
      >
        <span className="label">
          More Info and Buy
        </span>
        <span className="disclosure">
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 1000 1000" enable-background="new 0 0 1000 1000" xmlSpace="preserve">
              <g><path d="M579.5,879.8c-43.7,75.7-115.3,75.7-159,0L28.7,201.1c-43.7-75.7-8-137.7,79.5-137.7h783.7c87.5,0,123.2,62,79.5,137.7L579.5,879.8z"/></g>
          </svg>
        </span>
      </div>
      <div
        className={`further-reading__dropdown__options ${expanded ? 'expanded' : ''}`}
      >
        {props.data.Publisher_URL && (
          <div className="further-reading__dropdown__item">
            <a
              href={props.data.Publisher_URL}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => closeDropdown(bodyClickHandler, setBodyClickHandler, setExpanded)}
            >
              Publisher’s Website
            </a>
          </div>
        )}
        {props.data.US_Bookshop && (
          <div className="further-reading__dropdown__item">
            <a
              href={`https://bookshop.org/a/81479/${props.data.US_Bookshop}`}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => closeDropdown(bodyClickHandler, setBodyClickHandler, setExpanded)}
            >
              Bookshop.org (US)
            </a>
          </div>
        )}
        {props.data.UK_Bookshop && (
          <div className="further-reading__dropdown__item">
            <a
              href={`https://uk.bookshop.org/a/9706/${props.data.UK_Bookshop}`}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => closeDropdown(bodyClickHandler, setBodyClickHandler, setExpanded)}
            >
              Bookshop.org (UK)
            </a>
          </div>
        )}
        {props.data.ASIN && (
          <div className="further-reading__dropdown__item">
            <a
              href={`https://www.amazon.com/dp/${props.data.ASIN}/ref=nosim?tag=thepubdomrev-20`}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => closeDropdown(bodyClickHandler, setBodyClickHandler, setExpanded)}
            >
              Amazon (US)
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default FurtherReadingDropdown;